
import Vue from "vue";
import box from "@/components/BoxCom.vue";
import rate from "@/components/DataRateCom.vue";
import lineChart from "@/components/Charts/LineChartCom.vue";
import rlineChart from "@/components/Charts/RLineChartCom.vue";
import pieChart from "@/components/Charts/PieCharCom.vue";
import alarmAnimate from "@/components/AlarmAnimateCom.vue";
import { EchartInitModel } from "@/assets/js/Model/InnerModel";
import { getColors } from "@/assets/js/EchartUtil";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import Utils from "@/assets/js/Utils";
import AIAskCom from "./ShareComponents/AIAskCom.vue";
import { StoreTypes } from "@/assets/js/Types";
export default Vue.extend({
  components: { box, rate, lineChart, rlineChart, alarmAnimate, AIAskCom },
  data() {
    return {
      alarmLoading: true,
      deviceLoading: true,
      timeLoading: true,
      monthLoading: true,
      yearLoading: true,
      deviceTitle: {
        pic: require("@/assets/img/icon/icon-title-device.png"),
        title: this.$t("设备统计分析"),
      },
      monthTitle: {
        pic: require("@/assets/img/icon/icon-title-device.png"),
        title: this.$t("当月能耗对比分析"),
        deepseek: true,
      },
      engTitle: {
        pic: require("@/assets/img/icon/icon-title-eng.png"),
        title: this.$t("累计能耗分析"),
        dateifx: true,
        exbutton: "导出",
        deepseek: true,
      },
      alarmTitle: {
        pic: require("@/assets/img/icon/icon-title-alarmchart.png"),
        title: this.$t("开关灯时间"),
        dateifx: true,
        deepseek: true,
      },
      alarmActionTitle: {
        pic: require("@/assets/img/icon/icon-title-alarm.png"),
        title: this.$t("告警处理"),
        dateifx: true,
      },
      realAlarmTitle: {
        pic: require("@/assets/img/icon/icon-title-realalarm.png"),
        title: this.$t("实时告警消息"),
        dateifx: true,
      },
      dataf: "d",
      rateDevice: {
        rate: "90%",
        desc: "设备在线率",
        sum: 0,
        desc1: "在线数量",
        count: 0,
        pic: require("@/assets/img/icon/icon-online.png"),
      },
      rateAlarm: {
        rate: "0.01%",
        desc: "网关在线率",
        desc1: "在线数量",
        count: 0,
        sum: 0,
        pic: require("@/assets/img/icon/icon-alarm.png"),
      },
      rateLight: {
        rate: "99.5%",
        desc: "设备亮灯率",
        desc1: "亮灯数量",
        sum: 0,
        count: 0,
        pic: require("@/assets/img/icon/icon-light.png"),
      },
      thisMonthEng: 0,
      lastMonthEng: 0,
      monthEngRate: 0 as number,
      monthType: "",
      Colors: getColors(),
      alarms: [] as any[],
      dashData: {
        alarmReport: {},
      } as any,
      currentAlarm: {} as any,
      engerChart: [] as any[],
      currentMonth: 1 as number,
      timeData: {} as any,
      projectInfo: null as any,
      tran: Utils.getTran(),
    };
  },
  async mounted() {
    this.getDeviceData();
    this.projectInfo = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
    // await this.getData();
    // await this.datafix("y", 0);
    // this.initDeviceChart();
    // this.initMonthChart();
    // this.setTimeAuto();
    // this.initAlarmChart();
  },

  watch: {
    "$store.state.alarmAction"() {
      const list: any[] = this.$store.state.alarmList;
      if (list && list.length > 0) {
        const first = list[0];
        const animate: any = this.$refs.animate;
        animate.start(true);
        this.currentAlarm.deviceName = first.deviceName;
        this.currentAlarm.deviceTypeName = first.deviceTypeName;
        this.currentAlarm.alarmTypeName = first.alarmTypeName;
        this.currentAlarm.updateTime = first.updateTime;
        list.forEach((x: any) => {
          this.alarms.push(x);
        });
      }
    },
  },
  methods: {
    currentChange(val: any) {
      this.currentAlarm = val;
    },
    engDeepseek() {
      const dialog: any = this.$refs.aiDialog;
      if (this.dataf == "y") {
        const data = JSON.stringify(this.engerChart);
        const request = `下面是一个智慧路灯照明项目过去几个月的能耗数据，请对此数据做一个分析：${data}`;
        dialog.open(request);
      } else if (this.dataf == "m") {
        const data = JSON.stringify(this.engerChart);
        const request = `下面是一个智慧路灯照明项目一个月的能耗数据，请对此数据做一个分析：${data}`;
        dialog.open(request);
      }
    },
    aiLightOpen() {
      const dialog: any = this.$refs.aiDialog;
      const request = `这是一个智慧路灯照明项目，项目地的经度为${
        this.projectInfo.lng
      }纬度为${this.projectInfo.lat}，
      现在设置路灯的开灯时间为${this.timeData.onTime}秒,路灯的关灯设置为${
        this.timeData.offTime
      }秒,请以当前北京时间当前日期为依据，
      当前时间为${new Date().toDateString()}.
      分析一下该项目在当前时间路灯开关灯的时间是否合理`;
      dialog.open(request);
    },
    monthAi() {
      const dialog: any = this.$refs.aiDialog;
      const request = `这是一个智慧路灯照明项目，该项目上月的能耗为${this.lastMonthEng},
      本月截至到今天的能耗为${this.thisMonthEng},
      当前时间为北京时间${new Date().toDateString()}.
      上月及本月都是依据当前时间区分。请分析一下这两个数据`;
      dialog.open(request);
    },
    setTimeAuto() {
      window.setInterval(() => {
        const date = new Date();
        this.timeData.timeNow = `${date
          .getHours()
          .toString()
          .padStart(2, "0")}:${date
          .getMinutes()
          .toString()
          .padStart(2, "0")} ${date.getSeconds().toString().padStart(2, "0")}`;
      }, 1000);
    },
    getDeviceData() {
      this.deviceLoading = true;
      HttpUtil.XCHttpPost(Urls.GetDeviceDash, "", true, true).then((data: any) => {
        this.deviceLoading = false;
        this.dashData = data;

        if (this.projectInfo.sid == "2024062414045858424400727880809eb") {
          if (data.deviceData.online / data.deviceData.total > 0.7) {
            data.deviceData.online = Math.round(data.deviceData.total * 0.99);
            data.deviceData.open = data.deviceData.online;
          }
          data.deviceData.gatewayOnlineCount = data.deviceData.gatewayCount;
        }
        this.rateDevice.rate =
          data.deviceData.total == 0
            ? "0%"
            : Math.round((data.deviceData.online / data.deviceData.total) * 100) + "%";
        this.rateLight.rate =
          data.deviceData.total == 0
            ? "0%"
            : Math.round((data.deviceData.open / data.deviceData.total) * 100) + "%";
        this.rateAlarm.rate =
          data.deviceData.gatewayCount == 0
            ? "0%"
            : Math.round(
                (data.deviceData.gatewayOnlineCount / data.deviceData.gatewayCount) * 100
              ) + "%";
        this.rateDevice.sum = data.deviceData.total;
        this.rateLight.sum = data.deviceData.total;
        this.rateAlarm.sum = data.deviceData.gatewayCount;
        this.rateDevice.count = data.deviceData.online;
        this.rateAlarm.count = data.deviceData.gatewayOnlineCount;
        this.rateLight.count = data.deviceData.open;
        if (this.alarms.length > 0) {
          this.currentChange(this.alarms[0]);
        }
        this.initDeviceChart();
        // this.alarms = data.alarmList;
      });
      this.alarmLoading = true;
      HttpUtil.XCHttpPost(Urls.GetMapAlarmList, "", true, true).then((data: any) => {
        this.alarmLoading = false;
        this.alarms = data;
        if (this.alarms.length != 0) {
          this.currentAlarm = this.alarms[0];
        }
      });
      this.timeLoading = true;
      HttpUtil.XCHttpPost(Urls.GetLightOnTime, "", true, true).then((data: any) => {
        this.timeLoading = false;
        this.timeData = data;
      });
      this.monthLoading = true;
      HttpUtil.XCHttpPost(Urls.GetMonthVSEngery, "", true, true).then((data: any) => {
        this.monthLoading = false;
        this.dashData.monthEnger = data;
        this.initMonthChart();
      });
      const month = new Date().getMonth() + 1;
      this.datafix("m", month);
    },
    async getDataNew() {
      var data: any = await HttpUtil.XCHttpPost(Urls.GetDeviceDash, "", true, false);
      this.dashData = data;
      this.rateDevice.rate =
        Math.round((data.deviceData.online / data.deviceData.total) * 100) + "%";
      this.rateLight.rate =
        Math.round((data.deviceData.open / data.deviceData.total) * 100) + "%";
      this.rateAlarm.rate =
        Math.round((data.deviceData.alarm / data.deviceData.total) * 100) + "%";
      this.rateDevice.sum = data.deviceData.total;
      this.rateLight.sum = data.deviceData.total;
      this.rateAlarm.sum = data.deviceData.total;
      this.rateDevice.count = data.deviceData.online;
      this.rateAlarm.count = data.deviceData.alarm;
      this.rateLight.count = data.deviceData.open;
      this.alarms = data.alarmList;
      if (this.alarms.length > 0) {
        this.currentChange(this.alarms[0]);
      }
      this.timeData = await HttpUtil.XCHttpPost(Urls.GetLightOnTime, "", true, false);
    },
    async getData() {
      const year = new Date().getFullYear();
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetDashboard,
        { year: year },
        true,
        false
      );
      this.rateDevice.rate = ret.lightOnlinePercent + "%";
      this.rateLight.rate = ret.lightOpenPercent + "%";
      this.rateAlarm.rate = ret.lightAlarmPercent + "%";
      this.rateDevice.sum = ret.lightCount;
      this.rateLight.sum = ret.lightCount;
      this.rateAlarm.sum = ret.lightCount;
      if (ret.deviceStateReports && ret.deviceStateReports.length != 0) {
        const exsit = ret.deviceStateReports.find((x) => x.deviceName == "灯具");
        if (exsit) {
          this.rateDevice.count = exsit.onlineCount;
          this.rateAlarm.count = exsit.alarmCount;
          this.rateLight.count = Math.floor(
            (ret.lightOpenPercent * this.rateDevice.count) / 100
          );
        }
      }
      this.dashData = ret;
      this.alarms = this.dashData.deviceAlarms;
      if (this.alarms.length > 0) {
        this.currentChange(this.alarms[0]);
      }
    },
    datafix(command: string, month: number) {
      this.yearLoading = true;
      this.dataf = command;
      if (this.dataf == "y") {
        this.getEngerByYear().then((data: any) => {
          this.yearLoading = false;
          this.engerChart = data;
          this.initEngChart();
        });
      } else if (this.dataf == "m") {
        this.getEngerByMonth(month).then((data: any) => {
          this.yearLoading = false;
          this.engerChart = data;
          this.initEngChart();
        });
      }
    },
    async getEngerByYear() {
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetYearEnger, null, true, false);
      return ret;
    },
    async getEngerByMonth(month: number) {
      this.currentMonth = month * 1;
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetMonthEnger,
        month * 1,
        true,
        false
      );
      return ret;
    },
    async exp() {
      if (this.dataf == "y") {
        window.open(
          await HttpUtil.XCHttpPost(Urls.ExportDashboardYear, null, true, false)
        );
      } else if (this.dataf == "m") {
        window.open(
          await HttpUtil.XCHttpPost(
            Urls.ExportDashboardMonth,
            this.currentMonth * 1,
            true,
            false
          )
        );
      }
    },
    initAlarmChart() {
      const dchart: any = this.$refs.alarmChart;
      const data: EchartInitModel = {
        Data: [
          {
            Name: "设备告警分析",
            Data: [
              {
                value: this.dashData.alarmReport.processAlarmCount,
                name: "已处理",
              },
              {
                value: this.dashData.alarmReport.unProcessAlarmCount,
                name: "未处理",
              },
            ],
          },
        ],
        LegendConfig: {
          bottom: 10,
          textStyle: {
            color: this.tran ? "#fff" : "#000",
          },
        },
      };
      dchart.setOption(data);
    },
    initEngChart() {
      const labels: string[] = [];
      const datas: number[] = [];
      let title = "本年能耗分析";
      if (this.dataf == "y") {
        this.engerChart.forEach((x: any) => {
          x.total = parseFloat((x.total * 1).toFixed(2));
          labels.push(x.month);
          datas.push(x.total);
        });
      } else {
        this.engerChart.forEach((x: any) => {
          x.total = parseFloat((x.total * 1).toFixed(2));
          labels.push(x.day);
          datas.push(x.total);
          title = "本月能耗分析";
        });
      }
      const dchart: any = this.$refs.engChart;
      const data: EchartInitModel = {
        Labels: labels,
        Data: [
          {
            Name: title,
            Data: datas,
            Arear: {
              opacity: 0.3,
            },
          },
        ],
        isXValue: false,
        isInBar: false,
        Style: 0,
        LegendConfig: {
          textStyle: {
            color: this.tran ? "#fff" : "#000",
          },
          top: "10",
        },
      };
      dchart.setOption(data);
    },
    initMonthChart() {
      const dchart: any = this.$refs.monthChart;
      this.lastMonthEng = parseFloat(
        Math.round(this.dashData.monthEnger.lastMonth * 1).toFixed(2)
      );
      this.thisMonthEng = parseFloat((this.dashData.monthEnger.month * 1).toFixed(2));
      const data: EchartInitModel = {
        Labels: ["本月能耗", "上月能耗"],
        Data: [
          {
            Name: "能耗",
            Data: [
              this.thisMonthEng,
              {
                value: this.lastMonthEng,
                itemStyle: {
                  color: this.Colors[2],
                },
              },
            ],
          },
        ],
        isXValue: false,
        isInBar: true,
        Style: 0,
      };
      dchart.setOption(data);
      // const lrate: any = (this.lastMonthEng - this.thisMonthEng).toFixed(2);
      // if (lrate * 1 > 0) {
      //   this.monthType = "下降";
      // } else {
      //   this.monthType = "增加";
      //   this.monthEngRate = lrate * -1;
      // }
    },
    alarmClick() {
      const animate: any = this.$refs.animate;
      const open = animate.get();
      if (open) {
        animate.start(false);
      } else {
        HttpUtil.XCHttpPost(
          Urls.NotifyWeb,
          "2025123012161627041901085955023af",
          true,
          true
        );
      }
    },
    initDeviceChart() {
      const labels: any[] = ["景观", "网关", "灯控"];
      console.log(this.dashData);
      const onlineDatas: any[] = [
        this.dashData.deviceData.jgOlineCount,
        this.dashData.deviceData.gatewayOnlineCount,
        this.dashData.deviceData.online,
      ];
      const offlineDatas: any[] = [
        this.dashData.deviceData.jgCount - this.dashData.deviceData.jgOlineCount,
        this.dashData.deviceData.gatewayCount -
          this.dashData.deviceData.gatewayOnlineCount,
        this.dashData.deviceData.total - this.dashData.deviceData.online,
      ];
      const alarmDatas: any[] = [0, 0, this.dashData.deviceData.alarm];
      // this.dashData.deviceData.forEach((x: any) => {
      //   labels.push(x.deviceName);
      //   onlineDatas.push(x.onlineCount);
      //   offlineDatas.push(x.offlineCount);
      //   alarmDatas.push(x.alarmCount);
      // });
      const dchart: any = this.$refs.deviceChart;
      const data: EchartInitModel = {
        Colors: [this.Colors[0], this.Colors[1], this.Colors[2]],
        Labels: labels,
        Data: [
          {
            Name: "在线",
            Data: onlineDatas,
          },
          {
            Name: "离线",
            Data: offlineDatas,
          },
          {
            Name: "报警",
            Data: alarmDatas,
          },
        ],
        isXValue: true,
        isInBar: true,
        Style: 0,
        LegendConfig: {
          textStyle: {
            color: this.tran ? "#fff" : "#000",
          },
          right: "20",
          top: "10",
        },
      };
      dchart.setOption(data);
    },
  },
});
